var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenContainer25 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 55,
    viewBox: "0 0 127 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5775 10.0314H53.3796C53.3796 10.0314 52.9298 1.82111 63.2765 1.82111C73.6232 1.82111 73.6232 10.0314 73.6232 10.0314H71.4225",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1725 11.6735H63.9402",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1373 10.0314C55.1373 10.0314 56.1211 3.01795 63.4999 3.48552C70.8788 3.95308 71.8626 10.0314 71.8626 10.0314",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 1L4.08099 3.4631V10.0314H1V13.726H4.08099V41.6411C4.08099 41.6411 3.64085 44.5147 6.28169 46.9778C8.92254 49.4409 10.6831 49.4409 10.6831 49.4409H35.7711V53.9566H40.6127V49.4409H63.5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7712 49.4409V4.69464H40.6128V6.74722M40.6128 6.74722H53.817M40.6128 6.74722V49.4409M56.4579 6.74722H64.3804",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52124 6.74725H35.7712",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8275 11.6735H63.9401",
    stroke: "black",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5 1L122.919 3.4631V10.0314H126V13.726H122.919V41.6411C122.919 41.6411 123.359 44.5147 120.718 46.9778C118.077 49.4409 116.317 49.4409 116.317 49.4409H91.2289V53.9566H86.3873V49.4409H63.5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2288 49.4409V4.69464H86.3872V6.74722M86.3872 6.74722H73.183M86.3872 6.74722V49.4409M70.5421 6.74722H64.3802",
    stroke: "black",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.479 6.74725H91.2288",
    stroke: "black",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenContainer25);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/openContainer25.607df0fe0ef79270671747be0bf1f6b4.svg";